import React from 'react';
import clsx from 'clsx';
import { ICellProps } from 'shared/components/table/GridTable/GridTableModel';
import { TimeAndMoneyCell } from '../components/cells/abstract/TimeAndMoneyCell';
import { TableClasses } from '../model';
import { IGroupedSheetCalculationCommon } from 'modules/payrollProcessorHub/store/model';

type DoubleTimeHoursCellProps = ICellProps<IGroupedSheetCalculationCommon>;

export function makePtoCell(tableClasses: TableClasses) {
    return function PtoCell({
        className,
        time_pto_hours,
        time_pto_dollars,
    }: DoubleTimeHoursCellProps) {
        return (
            <TimeAndMoneyCell
                className={clsx(className, tableClasses.pullRight)}
                time={time_pto_hours}
                money={time_pto_dollars}
            />
        );
    };
}
